"use client";

import Image from "next/image";
import Link from "next/link";
import styles from "../styles/Footer.module.css";
import logo from "@/../public/images/logo.png"; // adjust path if needed

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Left Section */}
        <div className={styles.footerLeft}>
          <div className={styles.footerLogo}>
            <Image src={logo} alt="VGenomics" height={40} />
          </div>
          <p className={styles.footerTagline}>
            Accelerating Discoveries
            for Genetic Diseases
          </p>
        </div>

        {/* Middle Section */}
        <div className={styles.footerMiddle}>
          <Link href="https://vgenomics.in/company/" target="_blank">Company</Link>
          <Link href="https://vgenomics.in/solutions/" target="_blank">Solutions</Link>
          <Link href="https://vgenomics.in/our-science/" target="_blank">Our Science</Link>
          <Link href="https://vgenomics.in/patients/" target="_blank">Patients</Link>
          <Link href="https://vgenomics.in/careers/" target="_blank">Careers</Link>
        </div>

        {/* Right Section */}
        <div className={styles.footerRight}>
          <p>Delhi</p>
          <p>
            <a href="mailto:support@vgenomics.co.in">
              support@vgenomics.co.in
            </a>
          </p>
          <p>0120 4081198</p>
        </div>
      </div>

      {/* Bottom Section */}
      <div className={styles.footerBottom}>
        <div className={styles.footerBottomLinks}>
          <Link href="https://vgenomics.in/privacy-policy/" target="_blank">
            Privacy Policy
          </Link>
          <span>|</span>
          <Link href="https://vgenomics.in/terms-of-use/" target="_blank">
            Terms of Use
          </Link>
        </div>
        <p className={styles.footerCopy}>
          © 2025 VGenomics | All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
